import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';
import { selectUserDetailsData } from 'src/app/store/user-details/user-details.selectors';

// Whether the current visitor may see the TND payments guide page
// (/deposit-withdrawal-tn) and the nav links pointing to it: logged-in AND
// the account's country currency is TND. Guests and non-TND accounts get
// neither the links nor the page (TndPageGuard enforces the route itself).
// Same currency rule as the TND payment module and the welcome popup.
@Injectable({ providedIn: 'root' })
export class TndPagesVisibilityService {
  readonly canSeeTndPayments$: Observable<boolean>;

  constructor(authService: AuthService, store: Store) {
    this.canSeeTndPayments$ = combineLatest([
      authService.authStatusSub,
      store.select(selectUserDetailsData),
    ]).pipe(
      map(([credential, details]: [any, any]) => {
        if (!credential || !credential.uid) {
          return false;
        }
        const currency =
          (details &&
            (details.countryCurrency ||
              (details.country && details.country.currency))) ||
          '';
        return currency === 'TND';
      }),
      distinctUntilChanged()
    );
  }
}
